(() => {
  'use strict';
  const root = document.querySelector('[data-kw-native-results]');
  if (!root) return;
  const initialUrl = new URL(location.href);
  if (initialUrl.searchParams.getAll('filter.v.availability').join(',') !== '1' || initialUrl.searchParams.has('filter.v.option.size')) {
    initialUrl.searchParams.set('filter.v.availability', '1');
    initialUrl.searchParams.delete('filter.v.option.size');
    initialUrl.searchParams.delete('page');
    location.replace(initialUrl.href);
    return;
  }
  const form = root.querySelector('[data-kw-filter-form]');
  const home = root.querySelector('[data-kw-filter-home]');
  const drawer = root.querySelector('#kw-native-drawer');
  const drawerBody = root.querySelector('[data-kw-filter-drawer-body]');
  const openButton = root.querySelector('[data-kw-filter-open]');
  const closeButton = root.querySelector('[data-kw-filter-close]');
  const mobile = matchMedia('(max-width: 700px)');
  const preview = root.dataset.previewTheme;
  const sort = root.querySelector('#kw-native-sort');
  const perPage = root.querySelector('#kw-native-page-size');
  const serverView = perPage?.querySelector('option[selected]')?.value || 'kw-page-100';
  const serverSort = sort.querySelector('option[selected]')?.value || sort.options[0]?.value || '';
  root.classList.add('kw-native-enhanced');
  function enhanceLinks() {
    const action = new URL(form.action, location.href);
    const scope = form.querySelector('input[name="q"]');
    root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === action.pathname) {
        url.searchParams.set('filter.v.availability', '1');
        url.searchParams.delete('filter.v.option.size');
        if (perPage) url.searchParams.set('view', perPage.value);
      }
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (scope && url.pathname === action.pathname && !url.searchParams.has('q')) url.searchParams.set('q', scope.value);
      link.href = url.href;
    });
  }
  function closeDrawer() { if (drawer.open) drawer.close(); }
  function placeForm() {
    const focused = document.activeElement;
    const hadFormFocus = form.contains(focused);
    closeDrawer();
    (mobile.matches ? drawerBody : home).append(form);
    if (hadFormFocus) (mobile.matches ? openButton : focused).focus();
  }
  openButton.addEventListener('click', () => { drawer.showModal(); closeButton.focus(); });
  closeButton.addEventListener('click', closeDrawer);
  drawer.addEventListener('close', () => { if (mobile.matches) openButton.focus(); });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
  });
  mobile.addEventListener('change', placeForm);
  function syncControlsFromUrl() {
    const params = new URL(location.href).searchParams;
    form.querySelectorAll('input[name^="filter."]').forEach(input => {
      if (input.name === 'filter.v.availability') {
        input.value = '1';
      } else if (input.type === 'checkbox' || input.type === 'radio') {
        const values = params.getAll(input.name);
        input.checked = values.includes(input.value) || values.some(value => value.split(',').includes(input.value));
      } else {
        input.value = params.get(input.name) || '';
      }
      input.setCustomValidity('');
    });
    const requestedSort = params.get('sort_by');
    sort.value = Array.from(sort.options).some(option => option.value === requestedSort) ? requestedSort : serverSort;
    if (perPage) {
      const requestedView = params.get('view');
      perPage.value = Array.from(perPage.options).some(option => option.value === requestedView) ? requestedView : serverView;
    }
    closeDrawer();
  }
  window.addEventListener('pageshow', () => { syncControlsFromUrl(); enhanceLinks(); });
  form.addEventListener('invalid', event => {
    const field = event.target;
    const group = field.closest('details');
    if (group) group.open = true;
    if (mobile.matches && !drawer.open) drawer.showModal();
    field.focus();
  }, true);
  form.addEventListener('submit', event => {
    if (!form.reportValidity()) { event.preventDefault(); return; }
    const min = form.querySelector('[name$="price.gte"]');
    const max = form.querySelector('[name$="price.lte"]');
    if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
      event.preventDefault(); min.setCustomValidity(min.dataset.rangeError || 'Minimum price must not exceed maximum price.'); min.reportValidity(); return;
    }
    event.preventDefault();
    const url = new URL(form.action, location.href);
    new FormData(form).forEach((value, name) => { if (String(value).trim() !== '') url.searchParams.append(name, value); });
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('filter.v.option.size');
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  form.querySelectorAll('input[type="number"]').forEach(input => input.addEventListener('input', () => {
    form.querySelectorAll('input[type="number"]').forEach(field => field.setCustomValidity(''));
  }));
  sort.addEventListener('change', () => form.requestSubmit());
  syncControlsFromUrl();
  enhanceLinks();
  placeForm();
})();
